import { apiClient } from '@/libs/axios';
import type { ApiParamsDefault, ApiResponsePagination } from '@/types/api.type';
import { queryOptions } from '@tanstack/react-query';
import type { Admin } from '../types/admin.type';

export type GetListAdminParams = Partial<ApiParamsDefault>;
export type GetListAdminResponse = ApiResponsePagination<Admin>;

export const getListAdmin = async (
  params?: GetListAdminParams
): Promise<GetListAdminResponse> => {
  return await apiClient.get('admin', { params });
};

export const GET_LIST_ADMIN_QUERY_KEY = 'list-admin';
export function getListAdminQueryOptions(params?: GetListAdminParams) {
  return queryOptions({
    queryKey: [GET_LIST_ADMIN_QUERY_KEY, params],
    queryFn: () => getListAdmin(params),
  });
}
